import React from "react";
import WidgetContainer from "components/WidgetContainer/WidgetContainer";

import HideUpArrowIcon from "images/security-page/hide-icon.svg";
import SecurityFlowerImg from "images/security-page/km-flower.svg";
import SecurityTabImg from "images/security-page/km-tab.svg";
import "./SafetyKnowMoreCardWidget.css";

const SafetyKnowMoreCardWidget = () => {
    const showCardContent = e => {
        e.stopPropagation();
        e.target.parentElement.classList.remove("dynamic-card-height");
        e.target.parentElement.style.height = "auto";
        e.target.nextSibling.classList.add("show");
    };

    const hideCardContent = e => {
        e.stopPropagation();
        e.target.parentElement.classList.remove("show");
        e.target.parentElement.parentElement.classList.add(
            "dynamic-card-height"
        );
    };
    return (
        <WidgetContainer stylesClass="safetykmw-widget">
            <div className="safetykmw">
                <img src={SecurityFlowerImg} alt="" className="km-flower" />
                <img src={SecurityTabImg} alt="" className="km-tab" />
                <h2>Find out more about PhonePe Safety</h2>
                <div className="safetykmw-content">
                    <div className="safetykmw-content__container">
                        <div className="safetykmw-content__container__item">
                            <h3 onClick={showCardContent}>
                                How does PhonePe keep my payments safe?
                            </h3>
                            <div className="safetykmw-content__container__item__content">
                                <p>
                                    We assign a risk score to every transaction
                                    on the app. Transactions with high risk
                                    scores are automatically blocked, keeping
                                    your payment safe.
                                </p>
                                <img
                                    src={HideUpArrowIcon}
                                    alt=""
                                    onClick={hideCardContent}
                                />
                            </div>
                        </div>
                        <div className="safetykmw-content__container__item">
                            <h3 onClick={showCardContent}>
                                Where can I learn about payment fraud?
                            </h3>
                            <div className="safetykmw-content__container__item__content">
                                <p>
                                    Read our blogs to find out about the common
                                    types of fraud and how you can stay safe.
                                    <br />
                                    <a href="https://blog.phonepe.com/tagged/phishing">
                                        https://blog.phonepe.com/tagged/phishing
                                    </a>
                                </p>
                                <img
                                    src={HideUpArrowIcon}
                                    alt=""
                                    onClick={hideCardContent}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="safetykmw-content__container">
                        <div className="safetykmw-content__container__item open-parent">
                            <h3 onClick={showCardContent}>
                                What can I do to keep my transactions safe?
                            </h3>
                            <div className="safetykmw-content__container__item__content show">
                                <p>
                                    <ul>
                                        <li>
                                            Never share your UPI PIN, OTP, CVV
                                            and credit/debit card details with
                                            anyone
                                        </li>
                                        <li>
                                            Never enter your UPI PIN to receive
                                            money on PhonePe
                                        </li>
                                        <li>
                                            Never download third party apps,
                                            such as AnyDesk and TeamViewer at
                                            the request of unknown callers
                                        </li>
                                    </ul>
                                </p>
                                <img
                                    src={HideUpArrowIcon}
                                    alt=""
                                    onClick={hideCardContent}
                                />
                            </div>
                        </div>
                        <div className="safetykmw-content__container__item">
                            <h3 onClick={showCardContent}>
                                What’s the safest way to reach PhonePe support?
                            </h3>
                            <div className="safetykmw-content__container__item__content">
                                <p>
                                    The safest way to get the help you’re
                                    looking for is to write to us at:
                                    <br />
                                    <a href="https://support.phonepe.com/">
                                        support.phonepe.com
                                    </a>
                                    <br />
                                    <a href="https://www.phonepe.com/contact-us/">
                                        https://www.phonepe.com/contact-us/
                                    </a>
                                </p>
                                <img
                                    src={HideUpArrowIcon}
                                    alt=""
                                    onClick={hideCardContent}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="safetykmw-content__container">
                        <div className="safetykmw-content__container__item">
                            <h3 onClick={showCardContent}>
                                What if someone tries to login to my account?
                            </h3>
                            <div className="safetykmw-content__container__item__content">
                                <p>
                                    Any login from a new device will require an
                                    OTP, which is sent to your registered mobile
                                    number. If an incorrect OTP is used three
                                    times, your PhonePe account will be blocked
                                    for 24 hours, for your own safety.
                                </p>
                                <img
                                    src={HideUpArrowIcon}
                                    alt=""
                                    onClick={hideCardContent}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default SafetyKnowMoreCardWidget;
